import { UserRound, AtSign, ShieldCheck, LogOut } from "lucide-react";
import { useAuth } from "../hooks/useAuth";

export function Profile() {
  const { user, logout } = useAuth();

  return (
    <div className="max-w-lg space-y-4">
      <div className="rounded-xl border border-slate-800 bg-slate-900/60 p-6">
        <div className="flex items-center gap-4">
          <div className="flex h-14 w-14 items-center justify-center rounded-full bg-emerald-500/10">
            <UserRound className="h-7 w-7 text-emerald-400" />
          </div>
          <div>
            <h2 className="text-lg font-semibold text-slate-100">{user?.name}</h2>
            <p className="text-sm text-slate-500">{user?.role}</p>
          </div>
        </div>

        <dl className="mt-6 space-y-4 border-t border-slate-800 pt-4">
          <div className="flex items-center gap-3 text-sm">
            <AtSign className="h-4 w-4 text-slate-500" />
            <dt className="text-slate-500">Username</dt>
            <dd className="ml-auto font-medium text-slate-200">{user?.username}</dd>
          </div>
          <div className="flex items-center gap-3 text-sm">
            <ShieldCheck className="h-4 w-4 text-slate-500" />
            <dt className="text-slate-500">Role</dt>
            <dd className="ml-auto font-medium capitalize text-slate-200">{user?.role}</dd>
          </div>
        </dl>

        <button
          onClick={logout}
          className="mt-6 flex w-full items-center justify-center gap-2 rounded-lg border border-slate-700 px-4 py-2.5 text-sm font-medium text-slate-300 transition-colors hover:border-rose-800 hover:text-rose-400"
        >
          <LogOut className="h-4 w-4" />
          Log out
        </button>
      </div>
    </div>
  );
}
